export default "__VITE_ASSET__DSlwNQ24__"